export const UseCases = () => {
  return (
    // TODO: outline major use cases
    <div>
      <UseCases />
    </div>
  );
};
